import { JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../../base-types";
import type CultureInfo from "../../culture-info";
import Resource from "../resource";

@JsonObject()
export class LanguageResource extends Resource {
    @JsonProperty("id")
    id: number;

    @JsonProperty("name")
    name: string;

    @JsonProperty("culture")
    culture: CultureInfo;

    @JsonProperty("path")
    path: string;

    @JsonProperty("label")
    label: MapCultureTo<string> = {};
}
